import { SvgAsset, type TSvgAssetProps } from '../../components/svgAsset/SvgAsset';

const Edit = (props: TSvgAssetProps) => (
  <SvgAsset width="24" height="24" viewBox="0 0 24 24" fill="none" {...props}>
    <path
      stroke={props.stroke}
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
      d="M21.174 6.812a1 1 0 0 0-3.986-3.987L3.842 16.174a2 2 0 0 0-.5.83l-1.321 4.352a.5.5 0 0 0 .623.622l4.353-1.32a2 2 0 0 0 .83-.497z"
    />
    <path stroke={props.stroke} strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" d="m15 5 4 4" />
  </SvgAsset>
);

export default Edit;
